module.exports = __webpack_public_path__ + "static/media/logo600.22b59e90.webp";